import en from "./en.json";
import it from "./it.json";

const customers = { en, it };

export default customers;
